// The shared `Pagination` primitive speaks a zero-based row offset (`first`) + `rows`; this API
// speaks 1-based `page` + `page_size`. Both conversions live here so no component does the
// arithmetic — and so `INVALID_PAGINATION` (422 on a non-integer page) stays unreachable from the UI.

export const DEFAULT_PAGE_SIZE = 25
/** `page_size` maximum the spec accepts. */
export const MAX_PAGE_SIZE = 200

function positiveInt(value: number, fallback: number): number {
  return Number.isFinite(value) && Math.trunc(value) > 0 ? Math.trunc(value) : fallback
}

/** `first` (zero-based row offset) + `rows` → the 1-based page params the API expects. */
export function toPageParams(first: number, rows: number): { page: number; page_size: number } {
  const pageSize = Math.min(positiveInt(rows, DEFAULT_PAGE_SIZE), MAX_PAGE_SIZE)
  const offset = Number.isFinite(first) && first > 0 ? Math.trunc(first) : 0
  return { page: Math.floor(offset / pageSize) + 1, page_size: pageSize }
}

/** The 1-based page → the zero-based row offset `Pagination` binds to. */
export function toFirst(page: number, pageSize: number): number {
  const size = positiveInt(pageSize, DEFAULT_PAGE_SIZE)
  return (positiveInt(page, 1) - 1) * size
}
